import { render, staticRenderFns } from "./Drawer2nd.vue?vue&type=template&id=bc7197c8&"
import script from "./Drawer2nd.vue?vue&type=script&lang=js&"
export * from "./Drawer2nd.vue?vue&type=script&lang=js&"
import style0 from "./Drawer2nd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports